import axios from 'axios';
import {API} from "@/services/url";

export default {
	getUnpaidInvoiceList : function (pageNumber,perPage,searchKey,success, error) {
		axios.get(API.invoice.unpaid, {
			params: {
					pageNumber:pageNumber,
					perPage:perPage,
					searchKey:searchKey,
			}
		})
			.then(r => success(r.data))
			.catch(e => error(e));
	},

	getUnpaidInvoiceListNonPaginated : function (success, error) {
		return axios.get(API.invoice.unpaidNonPaginated)
			.then(r => success(r.data.invoiceList))
			.catch(e => error(e));
	},

	getUnapprovedInvoiceList : function (pageNumber,perPage,searchKey, success, error) {
		axios.get(API.invoice.unapproved,{
			params: {
				pageNumber:pageNumber,
				perPage:perPage,
				searchKey:searchKey,
			}
		})
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},

	getApprovedInvoiceList : function (success, error) {
		axios.get(API.invoice.approved)
			.then(r => success(r.data.invoiceList))
			.catch(e => error(e.response.data.message));
	},
	editAnInvoice: function (invoiceId,data, success, error) {
		axios.post(API.invoice.edit + invoiceId, data )
			.then(r => success(r.data.invoiceList))
			.catch(e => error(e.response.data.message));
	},
	approveAnInvoice: function (invoiceId, success, error) {
		axios.post(API.invoice.approve + invoiceId, {} )
			.then(r => success(r.data.invoiceList))
			.catch(e => error(e.response.data.message));
	},

	getInvoicesOfAProject : function (projectId, success, error) {
		axios.get(API.invoice.invoiceListOfAProject + projectId)
			.then(r => success(r.data.invoiceList))
			.catch(e => error(e.response.data.message));
	},

	downloadInvoice : function (invoiceId, success, error) {
		axios.get(API.invoice.download + invoiceId, {
			responseType : "blob"
		})
			.then(r => {
				let fileURL = window.URL.createObjectURL(new Blob([r.data]));
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'invoice-' + invoiceId + '.pdf');
				document.body.appendChild(fileLink);

				fileLink.click();
			})
			.catch(e => error(e));
	}
}
